import type {
  ActiveSubscription,
  UnsubscriberTransaction,
  UserSubscription,
} from "../../api/StatsAPI.types";

export const getSubscriptionPayment = (
  subscription: ActiveSubscription | UnsubscriberTransaction | UserSubscription,
): string => {
  if (!subscription) return "";

  const { payment_processor: paymentProcessor } = subscription;
  if (paymentProcessor === "retailer") {
    return "retailer";
  }

  if (paymentProcessor?.startsWith("stripe_")) {
    return "stripe";
  }

  if (paymentProcessor?.startsWith("paypal_")) {
    return "paypal";
  }

  if (paymentProcessor === "free_copy") {
    return "okast";
  }

  return paymentProcessor;
};
